import {useSelector} from "react-redux";
import HeaderNav from "./HeaderNav";
import MobileHeader from "./MobileHeader";

const Header = () => {
  const {component, profile, analytics} = useSelector(({componentReducer, profileReducer, analyticsReducer}) => ({
    component: componentReducer,
    profile: profileReducer,
    analytics: analyticsReducer,
  }));

  return (
    <>
      <HeaderNav component={component} profile={profile} onboardingStatus={analytics.onboardingStatus}/>
      <MobileHeader component={component}/>
    </>
  );
}

export default Header;
